//@ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import RenderIf from 'components/if-statement';
import SortIcon from 'components/grid/table/components/column/components/sort-icon';
import SortableIcon from 'components/grid/table/components/column/components/sortable-icon';
import { HeaderField } from '../../../../styled';
import { StyledLabel as Label } from 'components/grid/table/components/column/components/header/style';
import {
  SearchableContainer,
  SortableContainer,
  Input,
} from 'components/grid/table/components/column/components/header/style';
import { get, noop } from 'lodash';

export const propTypes = {
  align: PropTypes.string,
  setSort: PropTypes.func,
  isSortSet: PropTypes.func,
  getSortValue: PropTypes.func,
  setFilterKey: PropTypes.func,
  filter: PropTypes.object,
  sortKey: PropTypes.string,
  label: PropTypes.string,
  searchable: PropTypes.bool,
  tableSearchable: PropTypes.bool,
  name: PropTypes.string,
  showHeader: PropTypes.bool,
};

class Header extends React.Component {
  static propTypes = propTypes;

  static defaultProps = {
    align: 'left',
    label: '',
    name: '',
    sortKey: '',
    setSort: undefined,
    setFilterKey: noop,
    getSortValue: noop,
    isSortSet: noop,
    filter: {},
    searchable: false,
    tableSearchable: false,
    showHeader: true,
  };

  toggleSorter = () => this.props.setSort(this.props.sortKey);

  setFilterKey = (event) => {
    const { name, setFilterKey } = this.props;
    const value = get(event, 'target.value');
    setFilterKey(name, value);
  };

  render() {
    const {
      label,
      align,
      showHeader,
      searchable,
      sortKey,
      filter,
      tableSearchable,
      getSortValue,
      isSortSet,
      name,
    } = this.props;

    if (showHeader) {
      return (
        <React.Fragment>
          <HeaderField
            align={align}
            tableSearchable={tableSearchable}
            searchable={searchable}
            data-type="table-header"
            data-name={name}
            data-sort-by={sortKey}
            data-sort-direction={getSortValue(sortKey)}
            data-searchable={String(searchable)}
            data-sortable={String(Boolean(sortKey))}>
            <RenderIf condition={sortKey}>
              <SortableContainer onPress={this.toggleSorter}>
                <Label>{label}</Label>
                <RenderIf condition={isSortSet(sortKey)}>
                  <SortIcon sorted={getSortValue(sortKey)} />
                </RenderIf>
                <RenderIf condition={isSortSet(sortKey) === false}>
                  <SortableIcon />
                </RenderIf>
              </SortableContainer>
            </RenderIf>

            <RenderIf condition={!sortKey}>
              <Label>{label}</Label>
            </RenderIf>
            <RenderIf condition={searchable}>
              <SearchableContainer>
                <Input
                  name={this.props.name}
                  delay={2000}
                  onChange={this.setFilterKey}
                  value={get(filter, name, '')}
                />
              </SearchableContainer>
            </RenderIf>
          </HeaderField>
        </React.Fragment>
      );
    }

    return <HeaderField />;
  }
}

export default Header;
